'use-strict';

import { IScope } from 'angular';
import { CommentAPIService } from '../../../shared/api/comment-api.service';
import { InterfaceService } from '../../../shared/interface/interface.service';
import { Comment, ECommentContext, ECommentType } from '../../../src/app/@shared-types/misc/comment';
import { ToastService, ToastType } from '../../toast/toast.service';

/* @ngInject */
export default class DialogCommentsController {
  public context!: ECommentContext;

  public contextId!: string;

  public type!: ECommentType;

  public ghostComments = true;

  public exit!: () => void;

  private commentApiService: CommentAPIService;

  private interfaceService: InterfaceService;

  private toastService: ToastService;

  private $scope: IScope;

  public comments: Comment[] | null = null;

  constructor(
    commentApiService: CommentAPIService,
    interfaceService: InterfaceService,
    toastService: ToastService,
    $scope: IScope,
  ) {
    'ngInject';

    this.commentApiService = commentApiService;
    this.interfaceService = interfaceService;
    this.$scope = $scope;
    this.toastService = toastService;
  }

  public $onInit = (): void => {
    this.getComments();
  };

  private getComments = () => {
    this.commentApiService.getByContext(this.context, String(this.contextId))
      .then((comments) => {
        this.comments = comments.filter((c) => c.type === this.type);
        this.ghostComments = false;
        this.interfaceService.applyScope(this.$scope);
      })
      .catch(() => {
        this.exit();
        this.toastService.toast(ToastType.ERROR, 'Fehler beim Abrufen der Kommentare.');
      });
  };
}
